import {CountyList, countyList} from 'app/components/instituteSelection/data';
import {ListItem, StateProps} from 'app/components/instituteSelection/interfaces';
import {GemSettings} from 'app/utils/config/interface';
import {StateInstitutesConfig} from 'interfaces/ebspk/components/regionalization/instituteselection/stateInstitutesConfig';

export function getInstituteList(stateInstitutes: StateInstitutesConfig[], selectedCountry?: StateProps['selectedCountry']): ListItem[] {
    const federalState = selectedCountry && countyList.find((item) => item.id === selectedCountry)?.federalState;

    const matchingStates = stateInstitutes.filter((state) => state.stateCode === federalState);

    return matchingStates.flatMap((state) =>
        state.institutes.map((institute) => ({
            id: institute.id,
            instituteNumber: institute.code,
            name: institute.name,
            isAvailable: true,
            stateCode: state.stateCode,
        })),
    );
}

export function mapCountryList(list: CountyList[]): ListItem[] {
    return list.map((item) => {
        return {
            id: item.id,
            name: item.name,
            isAvailable: true,
            stateCode: item.federalState,
        };
    });
}

export function getInstituteUrl(gemSettings: GemSettings): string {
    const currentPagePath = gemSettings.pagePath;
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:3000/instituteSelection';
    }
    return `/cacheable/institutes.json${currentPagePath}.json`;
}

export function getCookieNameForHash(cId: string): string {
    return `hash_${cId}`;
}
